import { DataQueryField } from './data-query-field.model';
import { DataQueryRelationship } from './data-query-relationship.model';

export class DataQueryCluster {

    // Properties
    fields: DataQueryField[] = [];
    relationships: DataQueryRelationship[] = [];

    // Constructor
    constructor(
        fields: DataQueryField[] = [],
        relationships: DataQueryRelationship[] = []
    ) {
        this.fields = fields;
        this.relationships = relationships;
    }

    // Accessors
    get size() {
        return this.fields.length;
    }

    // Functions
    addField(field: DataQueryField) {
        this.fields.push(field);
    }

    addRelationship(relationship: DataQueryRelationship) {
        this.relationships.push(relationship);
    }
}